import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import FormHeaderComponent from "../component/FormHeaderComponent";
import RestaurantDetailComponent from "../component/restaurants/RestaurantDetailComponent";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";
import CustomLoader from "../component/menu/CustomLoader";

export default function RestaurantDetails() {
  const { user, setNetworkCall, showNotification } = useUserStore();
  const params = useParams();
  const { restaurantId } = params;
  const [restaurant, setRestaurant] = useState({
    banner: "",
    categories: [],
    openTime: "",
    closeTime: "",
    images: [],
    logo: "",
    name: "",
    openDays: [],
    status: "",
    inventoryType: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalBranch, setTotalBranch] = useState(0);
  const [branches, setBranches] = useState([]);
  const [isBranchStatusChange, setIsBranchStatusChange] = useState(false);

  async function getRestaurantDetails(id) {
    if (id === null) return;

    setNetworkCall(true);
    const token = user.token.token;

    try {
      const res = await ApiService.GET_RESTAURANT_WITH_ID(id, token);
      if (!res || res.code !== 200) {
        showNotification(res?.message || "Failed to fetch restaurant details");
        return;
      }

      const record = res?.payload;
      setRestaurant({ ...record });
    } catch (err) {
      showNotification(err?.response?.data?.message || "Something went wrong");
    } finally {
      setNetworkCall(false);
    }
  }


  async function getRestaurantBranches(params) {
    const token = user.token.token;
    setNetworkCall(true);

    try {
      const res = await ApiService.GET_RESTAURANT_BRANCHES(params, token);
      if (!res || res.code !== 200) {
        showNotification(res?.message || "Failed to fetch restaurant branches");
        return;
      }

      const { payload } = res;
      setCurrentPage(payload.page);
      setPerPage(payload.perPage);
      setTotalBranch(payload.total);
      setBranches([...payload.records]);
    } catch (err) {
      showNotification(err?.response?.data?.message || "Something went wrong");
    } finally {
      setNetworkCall(false);
    }
  }

  useEffect(() => {
    if (restaurantId === "") return;
    async function getRestauantData() {
      await getRestaurantDetails(restaurantId);
    }

    getRestauantData();

  }, [restaurantId]);

  useEffect(() => {
    if (restaurantId === "") return;

    async function getBranchData() {
      const branchParams = {
        restaurantId: restaurantId,
        searchKey: "",
        status: "",
        page: currentPage,
        perPage: perPage,
      };
      await getRestaurantBranches(branchParams);
    }

    if (isBranchStatusChange) {
      setIsBranchStatusChange(false);
      return;
    }

    getBranchData();

  }, [restaurantId, isBranchStatusChange]);

  return (
    <div className="flex flex-col bg-[#e5e7eb]">
      <Header
        title={""}
        menu={constants.SUPER_MENU.RESTAURANT}
        currentMenuKey={'T_51_S_51'}
      />
      <div className="flex flex-row bg-prewhite">
        <SideMenu
          title={`McDonalds Food Chain`}
          menu={constants.SUPER_MENU.RESTAURANT}
        />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[80px]">
          <CustomLoader />
          <div className="flex flex-col w-full">
            <FormHeaderComponent
              title={restaurant.name}
              listRoute="/restaurants" />
            <div className="flex flex-col">
              {Boolean(restaurant.name) && (
                <RestaurantDetailComponent
                  records={{
                    restaurant: restaurant,
                    restaurantId: restaurantId,
                    branches: branches,
                  }}
                  setIsBranchStatusChange={setIsBranchStatusChange}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
